export const TokenTypes = {
  error:    "USER/TOKEN/ERROR",
  pending:  "USER/TOKEN/PENDING",
  success:  "USER/TOKEN/SUCCESS",
  set:      "USER/TOKEN/SET",
  unset:    "USER/TOKEN/UNSET",
  sync:     "USER/TOKEN/SYNC"
};

export const PersonTypes = {
  error:    "USER/PERSON/ERROR",
  pending:  "USER/PERSON/PENDING",
  success:  "USER/PERSON/SUCCESS",
  set:      "USER/PERSON/SET",
  unset:    "USER/PERSON/UNSET",
  sync:     "USER/PERSON/SYNC",

  updatePerson: "USER/PERSON/UPDATE_PERSON",
  instagramSet: "USER/PERSON/INSTAGRAM_SET"
};

export const RewardTypes = {
  error:    "USER/REWARDS/ERROR",
  pending:  "USER/REWARDS/PENDING",
  success:  "USER/REWARDS/SUCCESS",
  set:      "USER/REWARDS/SET",
  unset:    "USER/REWARDS/UNSET",
  sync:     "USER/REWARDS/SYNC"
};

export const EditionTypes = {
  error:    "USER/EDITIONS/ERROR",
  pending:  "USER/EDITIONS/PENDING",
  success:  "USER/EDITIONS/SUCCESS",
  set:      "USER/EDITIONS/SET",
  unset:    "USER/EDITIONS/UNSET",
  sync:     "USER/EDITIONS/SYNC"
};

export const NotificationTypes = {
  error:    "USER/NOTIFICATIONS/ERROR",
  pending:  "USER/NOTIFICATIONS/PENDING",
  success:  "USER/NOTIFICATIONS/SUCCESS",
  set:      "USER/NOTIFICATIONS/SET",
  unset:    "USER/NOTIFICATIONS/UNSET",
  sync:     "USER/NOTIFICATIONS/SYNC",
  read:     "USER/NOTIFICATIONS/READ"
};

export const SubscribersTypes = {
  error:    "USER/SUBSCRIBERS/ERROR",
  pending:  "USER/SUBSCRIBERS/PENDING",
  success:  "USER/SUBSCRIBERS/SUCCESS",
  set:      "USER/SUBSCRIBERS/SET",
  unset:    "USER/SUBSCRIBERS/UNSET",
  sync:     "USER/SUBSCRIBERS/SYNC"
};

export const BeautyTypes = {
  error:    "USER/BEAUTY_PROFILE/ERROR",
  pending:  "USER/BEAUTY_PROFILE/PENDING",
  success:  "USER/BEAUTY_PROFILE/SUCCESS",
  set:      "USER/BEAUTY_PROFILE/SET",
  unset:    "USER/BEAUTY_PROFILE/UNSET",
  sync:     "USER/BEAUTY_PROFILE/SYNC"
};

export const PartnerInfoTypes = {
  error:    "USER/PARTNER_INFO/ERROR",
  pending:  "USER/PARTNER_INFO/PENDING",
  success:  "USER/PARTNER_INFO/SUCCESS",
  set:      "USER/PARTNER_INFO/SET",
  unset:    "USER/PARTNER_INFO/UNSET",
  sync:     "USER/PARTNER_INFO/SYNC",

  updateInfo: "USER/PARTNER_INFO/UPDATE_INFO"
};

export const PartnerGeneralTypes = {
  error:    "USER/PARTNER_GENERAL/ERROR",
  pending:  "USER/PARTNER_GENERAL/PENDING",
  success:  "USER/PARTNER_GENERAL/SUCCESS",
  set:      "USER/PARTNER_GENERAL/SET",
  unset:    "USER/PARTNER_GENERAL/UNSET",
  sync:     "USER/PARTNER_GENERAL/SYNC"
};

export const PartnerSalesTypes = {
  error:    "USER/PARTNER_SALES/ERROR",
  pending:  "USER/PARTNER_SALES/PENDING",
  success:  "USER/PARTNER_SALES/SUCCESS",
  set:      "USER/PARTNER_SALES/SET",
  unset:    "USER/PARTNER_SALES/UNSET",
  sync:     "USER/PARTNER_SALES/SYNC"
};

export const PartnerResultsTypes = {
  error:    "USER/PARTNER_RESULTS/ERROR",
  pending:  "USER/PARTNER_RESULTS/PENDING",
  success:  "USER/PARTNER_RESULTS/SUCCESS",
  set:      "USER/PARTNER_RESULTS/SET",
  unset:    "USER/PARTNER_RESULTS/UNSET",
  sync:     "USER/PARTNER_RESULTS/SYNC"
};

export const PaymentTypes = {
  error:    "USER/PAYMENT/ERROR",
  pending:  "USER/PAYMENT/PENDING",
  success:  "USER/PAYMENT/SUCCESS",
  set:      "USER/PAYMENT/SET",
  unset:    "USER/PAYMENT/UNSET",
  sync:     "USER/PAYMENT/SYNC"
};

export const InfluencerPaymentTypes = {
  error:    "USER/INFLUENCER_PAYMENT/ERROR",
  pending:  "USER/INFLUENCER_PAYMENT/PENDING",
  success:  "USER/INFLUENCER_PAYMENT/SUCCESS",
  set:      "USER/INFLUENCER_PAYMENT/SET",
  unset:    "USER/INFLUENCER_PAYMENT/UNSET",
  sync:     "USER/INFLUENCER_PAYMENT/SYNC"
};

export const CreditCardTypes = {
  error:    "USER/CREDITCARD/ERROR",
  pending:  "USER/CREDITCARD/PENDING",
  success:  "USER/CREDITCARD/SUCCESS",
  set:      "USER/CREDITCARD/SET",
  unset:    "USER/CREDITCARD/UNSET",
  sync:     "USER/CREDITCARD/SYNC"
};

export const PartnerStatusActions = {
  error:    "USER/PARTNER_STATUS/ERROR",
  pending:  "USER/PARTNER_STATUS/PENDING",
  success:  "USER/PARTNER_STATUS/SUCCESS",
  set:      "USER/PARTNER_STATUS/SET",
  unset:    "USER/PARTNER_STATUS/UNSET",
  sync:     "USER/PARTNER_STATUS/SYNC"
};

export const InfluencerReportTypes = {
  error:    "USER/INFLUENCER_REPORT/ERROR",
  pending:  "USER/INFLUENCER_REPORT/PENDING",
  success:  "USER/INFLUENCER_REPORT/SUCCESS",
  set:      "USER/INFLUENCER_REPORT/SET",
  unset:    "USER/INFLUENCER_REPORT/UNSET",
  sync:     "USER/INFLUENCER_REPORT/SYNC"
};

export const FileTypes = {
  error:    "USER/FILE/ERROR",
  pending:  "USER/FILE/PENDING",
  success:  "USER/FILE/SUCCESS",
  set:      "USER/FILE/SET",
  unset:    "USER/FILE/UNSET",
  sync:     "USER/FILE/SYNC"
};

export const INSTAGRAM_INFO_SET = "INSTAGRAM_INFO_SET";
export const INSTAGRAM_INFO_UNSET = "INSTAGRAM_INFO_UNSET";
